import { motion } from "framer-motion";
import type { ReactNode } from "react";

interface AnimateInProps {
  children: ReactNode;
  delay?: number;
  duration?: number;
  y?: number;
  className?: string;
  style?: React.CSSProperties;
}

const ease = [0.25, 0.46, 0.45, 0.94] as const;

/** Fade + slide-up on scroll into view. Fires once. */
export function AnimateIn({
  children,
  delay = 0,
  duration = 0.55,
  y = 24,
  className,
  style,
}: AnimateInProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration, delay, ease }}
      className={className}
      style={style}
    >
      {children}
    </motion.div>
  );
}

/* eslint-disable react-refresh/only-export-components -- animation variants intentionally co-located */
/** Container variant: propagates to children so they stagger. */
export const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

/** Item variant: used inside a staggerContainer. */
export const fadeUpItem = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease },
  },
};
/* eslint-enable react-refresh/only-export-components */
